import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import queryString from "query-string";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";

import { connect } from "react-redux";
import { act_login, act_logout, act_sso } from "../../redux/actions";

import { SYS_CODE, SYS_NAME, SYS_INFO_OUT } from "../../utils/contrains";
import logo from "../../assets/images/logo.png";
import "./login.less";

/*
登入的路由組件
*/
const Item = Form.Item;

class Login extends Component {
  onFinish = async (values) => {
    const { username, password } = values;
    let user_captcha = document.getElementById("user_captcha_input").value;
    if (validateCaptcha(user_captcha) === true) {
      this.props.act_login(username, password);
    } else {
      document.getElementById("user_captcha_input").value = "";
      message.info("驗證碼輸入錯誤");
      loadCaptchaEnginge(4, "purple", "white", "numbers");
    }
  };

  validatePwd = (rule, value) => {
    // console.log(value)
    // if(/^[a-zA-Z0-9_]+$/.text(value)){ // 必須輸入是英文、數字或下滑線}
    return !value ? Promise.reject("必須輸入數據") : Promise.resolve(value);
  };

  componentDidMount() {
    const parsed = queryString.parse(window.location.search);
    const isEmpty = Object.values(parsed).every((x) => x === null || x === "");
    //console.log(isEmpty)
    if (isEmpty) {
      loadCaptchaEnginge(4, "purple", "white", "numbers");
    }
  }

  passPlaceholder = (expr) => {
    switch (expr) {
      case "GAM":
      case "GQM":
      case "AMS":
        return "預設生日8碼(YYYYMMDD)";
      default:
        return "南應大入口密碼";
    }
  };

  accPlaceholder = (expr) => {
    switch (expr) {
      // case "GAM":
      case "GQM":
      case "AMS":
        return "身分證字號";
      default:
        return "南應大入口帳號";
    }
  };

  render() {
    // <div style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}><span style={{color:'yellow'}}>06月18日0900時 正式開放預約</span></div>
    const user = this.props.user;
    if (user && user.token) {
      return <Redirect to="/home" />;
    } else {
      const errorMeg = this.props.user.error_msg;
      return (
        <div className="login">
          <header className="login-header">
            <img src={logo} alt="logo" />
            <h1>{SYS_NAME}</h1>
          </header>
          <section className="login-content">
            {errorMeg ? message.error(errorMeg) : null}
            <h2 style={{ color: "Plum" }}>用戶登錄</h2>

            <div>
              <Form
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
                name="normal_login"
                className="login-form"
              >
                <Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須輸入帳號",
                    },
                    { min: 3, message: "不符合帳號長度" },
                    { pattern: /^[a-zA-Z0-9_]+$/, message: "不符合帳號格式" },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder={this.accPlaceholder(SYS_CODE)}
                  />
                </Item>
                <Item name="password" rules={[{ validator: this.validatePwd }]}>
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder={this.passPlaceholder(SYS_CODE)}
                  />
                </Item>
                <Item>
                  <div style={{ float: "left" }}>
                    <LoadCanvasTemplateNoReload />
                  </div>
                  <div style={{ float: "left" }}>
                    <span> &nbsp;</span>
                  </div>
                  <div style={{ float: "left" }}>
                    <input
                      placeholder="輸入驗證碼"
                      id="user_captcha_input"
                      name="user_captcha_input"
                      className="form-control input-sm"
                      style={{ width: "155px", height: "31px" }}
                      type="text"
                      maxLength="4"
                      minLength="4"
                    ></input>
                  </div>
                </Item>
                <Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    登入
                  </Button>
                </Item>

                <Item>
                  <div className="login-meno">
                    <span>{SYS_INFO_OUT}</span>
                  </div>
                  <div className="login-meno">
                    <span>
                      系統開發：圖資中心 {SYS_CODE === "GQM" ? "" : "#261"}
                    </span>
                  </div>
                </Item>
              </Form>
              {/*SYS_CODE === 'GQM' ? (<div className="login-info"><div className="login-info-header"><i className="fas fa-money-check-alt"></i><span style={{ marginLeft: '4px' }}>抽獎資訊</span></div>本次10份壹仟元7-11禮巻抽獎活動，得獎名單預於2021年9月1日公佈至 <a href="https://www.tut.edu.tw/" className="login-link">本校首頁→最新消息</a>，如有未盡事宜，主辦單位保有調整及最終解釋權之權利</div>) : ''*/}
            </div>
          </section>
        </div>
      );
    }
  }
}

export default connect((state) => ({ user: state.user }), {
  act_login,
  act_logout,
  act_sso,
})(Login);
